const initialState = {
  // Getting FbrSnroTesting List
  isGettingFbrSnroTesting: false,
  fbrSnroListList: [],

  // is Adding FbrSnroTesting
  isAddingFbrSnroTesting: false,

  // is Updating FbrSnroTesting
  isUpdatingFbrSnroTesting: false,

  // is Deleting FbrSnroTesting
  isDeletingFbrSnroTesting: false,
};

const FBRSnroTestingReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting FbrSnroTesting List
    case "FBR_SNRO_TESTING_LIST_REQUEST":
      return {
        ...state,
        isGettingFbrSnroTesting: true,
      };
    case "FBR_SNRO_TESTING_LIST_SUCCESS":
      return {
        ...state,
        fbrSnroListList: action.payload?.data,
        isGettingFbrSnroTesting: false,
      };
    case "FBR_SNRO_TESTING_LIST_ERROR":
      return {
        ...state,
        isGettingFbrSnroTesting: false,
      };
    // Editing FbrSnroTesting List
    case "ADD_FBR_SNRO_TESTING_REQUEST":
      return {
        ...state,
        isAddingFbrSnroTesting: true,
      };
    case "ADD_FBR_SNRO_TESTING_SUCCESS":
      return {
        ...state,
        isAddingFbrSnroTesting: false,
      };
    case "ADD_FBR_SNRO_TESTING_ERROR":
      return {
        ...state,
        isAddingFbrSnroTesting: false,
      };
    // Updateing FbrSnroTesting List
    case "UPDATE_FBR_SNRO_TESTING_LIST_REQUEST":
      return {
        ...state,
        isUpdatingFbrSnroTesting: true,
      };
    case "UPDATE_FBR_SNRO_TESTING_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingFbrSnroTesting: false,
      };
    case "UPDATE_FBR_SNRO_TESTING_LIST_ERROR":
      return {
        ...state,
        isUpdatingFbrSnroTesting: false,
      };
    // Deleting FbrSnroTesting List
    case "DELETE_FBR_SNRO_TESTING_LIST_REQUEST":
      return {
        ...state,
        isDeletingFbrSnroTesting: true,
      };
    case "DELETE_FBR_SNRO_TESTING_LIST_SUCCESS":
      return {
        ...state,
        isDeletingFbrSnroTesting: false,
      };
    case "DELETE_FBR_SNRO_TESTING_LIST_ERROR":
      return {
        ...state,
        isDeletingFbrSnroTesting: false,
      };
    default:
      return state;
  }
};

export default FBRSnroTestingReducer;
